import Vue from "vue";

export default {
	state: {
		configurations: {},
		serasaReports: [],
		reports: []
	},
	mutations: {
		setConfigurationOnState(state, configurations) {
			state.configurations = mapConfiguration(configurations);
		},
		setReportsOnState(state, reports) {
			state.reports = reports;
		},
		setSerasaReportsOnState(state, serasaReports) {
			state.serasaReports = serasaReports;
		}
	},
	actions: {
		getConfigurationSupplierLogin(_, idClient) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get(`configuration/${idClient}/supplierLogin`)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch(() => {
						reject();
					});
			});
		},
		getConfigurationByClient({ commit }, payload) {
			const { idClient, configurationNameList, isIframeContext = false } = payload;
			const configurationData = { idClient, configurationNameList };
			const options = { isIframeContext };

			return new Promise((resolve, reject) => {
				this.state.loading = true;
				Vue.prototype.$http
					.post("configuration/clientConfiguration", configurationData, options)
					.then((response) => {
						if (configurationNameList.some((config) => config === "EnableUpperCase")) {
							const upperLetterConfig = response.data.data.configurationList.find(
								(config) => config.name === "EnableUpperCase"
							)?.value;

							localStorage.setItem("enableUpperLetter", JSON.stringify(parseInt(upperLetterConfig) > 0));
						}

						resolve(response.data.data.configurationList);
						commit("setConfigurationOnState", response.data.data.configurationList);
						commit("setSerasaReportsOnState", response.data.data.serasaReports);
					})
					.catch((error) => {
						console.error(error);
						reject();
					})
					.finally(() => {
						this.state.loading = false;
					});
			});
		},
		updateConfiguration(_, updateData) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("configuration", updateData)
					.then(() => {
						this.state.loading = false;
						resolve();
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getSerasaReports({ commit }) {
			return new Promise((resolve, reject) => {
				this.state.loading = true;
				Vue.prototype.$http
					.get("configuration/serasaReport")
					.then((response) => {
						resolve(response.data.data.serasaReports);
						commit("setReportsOnState", response.data.data.serasaReports);
					})
					.catch((error) => {
						console.error(error);
						reject();
					})
					.finally(() => {
						this.state.loading = false;
					});
			});
		},
		updateReportOptions(_, data) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("configuration/serasaReport", data)
					.then(() => {
						this.state.loading = false;
						resolve();
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		}
	},
	getters: {
		configurations(state) {
			return state.configurations;
		},
		serasaReports(state) {
			return state.serasaReports;
		},
		reports(state) {
			return state.reports;
		}
	}
};
const mapConfiguration = (configurations) => {
	if (configurations) {
		let mappedConfiguration = {
			isAutomatic: false,
			calendarDays: 0,
			deadlineType: 0,
			idWorkflow: 0,
			idCreator: 0,
			supplierParent: false,
			supplierParentURL: false,
			supplierParentAutoOffer: false,
			supplierParentWorkflowAutoOffer: 0,
			SapEnabled: 0,
			SapURL: "",
			SapUsername: "",
			SapPassword: "",
			SapDestination: "",
			SapTokenURL: "",
			SapClientId: "",
			SapClientSecret: "",
			SapApiKey: "",
			SerasaUser: "",
			SerasaPassword: "",
			SerasaBaseURL: "",
			DataBankObrigatority: false,
			MunicipalAndStateRegistration: false,
			AttachmentEmailInvitation: false,
			HideRelationshipTab: false,
			MandatoryInviteRegistrationData: false,
			OverwriteSupplierClientName: false,
			SendCopyInviteEmail: false,
			AllowScore: false,
			ExpandFamilyTree: false,
			MaterialFamilyTitle: "Família de Materiais",
			PartialSaving: false,
			IntegrationURL: "",
			IdWorkflowKlassmatt: "",
			CreateSAIKlassmattURL: "",
			EnableUpperCase: false,
			PasswordValidityDays: "0",
			IdQuestionKlassmattIntegration: { idQuestion: 0, idRequirement: 0 },
			SingleCompanySelection: false,
			BlockDuplicateInvitesByCpfCnpj: false
		};

		configurations.forEach((configuration) => {
			switch (configuration.name) {
				case "RehomologationAuto":
					mappedConfiguration.isAutomatic = parseInt(configuration.value) > 0;
					break;

				case "RehomologationDays":
					const calendarDays = Math.abs(parseInt(configuration.value));
					mappedConfiguration.calendarDays = calendarDays.toString();
					mappedConfiguration.deadlineType =
						calendarDays < 0 ? "1" : calendarDays === 0 ? (mappedConfiguration.isAutomatic ? "2" : "0") : "3";
					break;

				case "RehomologationWorkflow":
					mappedConfiguration.idWorkflow = configuration.value;
					break;

				case "SupplierParent":
					mappedConfiguration.supplierParent = parseInt(configuration.value) > 0;
					break;

				case "RehomologationUserCreator":
					mappedConfiguration.idCreator = configuration.value;
					break;

				case "SupplierParentURL":
					mappedConfiguration.supplierParentURL = parseInt(configuration.value) > 0;
					break;

				case "SupplierParentAutoOffer":
					mappedConfiguration.supplierParentAutoOffer = parseInt(configuration.value) > 0;
					break;

				case "SupplierParentWorkflowAutoOffer":
					mappedConfiguration.supplierParentWorkflowAutoOffer = configuration.value;
					break;

				case "SapEnabled":
					mappedConfiguration.SapEnabled = parseInt(configuration.value);
					break;

				case "SapURL":
					mappedConfiguration.SapURL = configuration.value;
					break;

				case "SapDestination":
					mappedConfiguration.SapDestination = configuration.value;
					break;

				case "SapUsername":
					mappedConfiguration.SapUsername = configuration.value;
					break;

				case "SapPassword":
					mappedConfiguration.SapPassword = configuration.value;
					break;

				case "SapTokenURL":
					mappedConfiguration.SapTokenURL = configuration.value;
					break;

				case "SapClientId":
					mappedConfiguration.SapClientId = configuration.value;
					break;

				case "SapClientSecret":
					mappedConfiguration.SapClientSecret = configuration.value;
					break;

				case "SapApiKey":
					mappedConfiguration.SapApiKey = configuration.value;
					break;

				case "SerasaUser":
					mappedConfiguration.SerasaUser = configuration.value;
					break;

				case "SerasaPassword":
					mappedConfiguration.SerasaPassword = configuration.value;
					break;

				case "SerasaBaseURL":
					mappedConfiguration.SerasaBaseURL = configuration.value;
					break;

				case "DataBankObrigatority":
					mappedConfiguration.DataBankObrigatority = parseInt(configuration.value) > 0;
					break;

				case "MunicipalAndStateRegistration":
					mappedConfiguration.MunicipalAndStateRegistration = parseInt(configuration.value) > 0;
					break;

				case "AttachmentEmailInvitation":
					mappedConfiguration.AttachmentEmailInvitation = parseInt(configuration.value) > 0;
					break;

				case "AllowScore":
					mappedConfiguration.AllowScore = parseInt(configuration.value) > 0;
					break;

				case "MaterialFamilyTitle":
					mappedConfiguration.MaterialFamilyTitle = configuration.value;
					break;

				case "OverwriteSupplierClientName":
					mappedConfiguration.OverwriteSupplierClientName = parseInt(configuration.value) > 0;
					break;

				case "HideRelationshipTab":
					mappedConfiguration.HideRelationshipTab = parseInt(configuration.value) > 0;
					break;

				case "OverwriteSupplierClientName":
					mappedConfiguration.OverwriteSupplierClientName = parseInt(configuration.value) > 0;
					break;

				case "SendCopyInviteEmail":
					mappedConfiguration.SendCopyInviteEmail = parseInt(configuration.value) > 0;
					break;

				case "ExpandFamilyTree":
					mappedConfiguration.ExpandFamilyTree = parseInt(configuration.value) > 0;
					break;

				case "PartialSaving":
					mappedConfiguration.PartialSaving = parseInt(configuration.value) > 0;
					break;

				case "IntegrationURL":
					mappedConfiguration.IntegrationURL = configuration.value;
					break;

				case "IdWorkflowKlassmatt":
					mappedConfiguration.IdWorkflowKlassmatt = configuration.value;
					break;

				case "CreateSAIKlassmattURL":
					mappedConfiguration.CreateSAIKlassmattURL = configuration.value;
					break;

				case "EnableUpperCase":
					mappedConfiguration.EnableUpperCase = parseInt(configuration.value) > 0;
					break;

				case "IdQuestionKlassmattIntegration":
					mappedConfiguration.IdQuestionKlassmattIntegration.idQuestion = parseInt(configuration.value);
					mappedConfiguration.IdQuestionKlassmattIntegration.idRequirement = parseInt(configuration.parentValue);
					break;

				case "PasswordValidityDays":
					mappedConfiguration.PasswordValidityDays = configuration.value.toString();
					break;

				case "SingleCompanySelection":
					mappedConfiguration.SingleCompanySelection = parseInt(configuration.value) > 0;
					break;

				case "BlockDuplicateInvitesByCpfCnpj":
					mappedConfiguration.BlockDuplicateInvitesByCpfCnpj = parseInt(configuration.value) > 0;
					break;

				default:
					break;
			}
		});
		return mappedConfiguration;
	}
	return null;
};
